import { INavigationLinkModel } from '@features/navigation/models/i-navigation-link.model';

export const mapLinkWithStateFactory =
  (url: string) =>
  (link: Partial<INavigationLinkModel>): INavigationLinkModel => ({
    ...(link as INavigationLinkModel),
    isActive: url.indexOf(link.route) !== -1,
  });
